import { shiftDayKey } from "./days";

/* "SHIFT THIS BLOCK FORWARD A WEEK" — W72 step 2 (Proposal 2: the missed-week action).
 *
 * A client who lost a week (illness, travel) should not have their plan silently compress: every TRAINING
 * assignment from THIS week onward moves +7 days, keeping its weekday and its order.
 *
 * 🔴 THE WRITES GO LATEST FIRST, AND THAT ORDER IS THE WHOLE CORRECTNESS OF THE ACTION.
 * `coach_assignments_one_source_per_day_idx` refuses two copies of one template on one day — so moving
 * Monday (week 1) to Monday (week 2) while week 2's own copy of that template still sits there is a 23505.
 * Moving the LAST day first always vacates the next target before anything needs it. (A shift BACKWARD — the
 * Programs board's `Remove week` — needs the opposite, lowest first: measured 2026-11-01, `removeWeekPlan`.)
 *
 * ⚠️ TWO THINGS STAY WHERE THEY ARE, and the confirm sentence says so: a day ALREADY TRAINED (its logged
 * sets are dated; moving the assignment away from them would orphan the record of what they did), and
 * TASKS (a daily wrist series is not the block — it continues on its own days).
 */

export type ShiftMove = { id: string; from: string; to: string };

export function shiftPlan(
  assignments: readonly { id: string; scheduledDateISO: string | null; isTask: boolean }[],
  fromMondayKey: string,
  trainedDays: ReadonlySet<string>,
): ShiftMove[] {
  const moves: ShiftMove[] = [];
  for (const a of assignments) {
    if (a.isTask || a.scheduledDateISO === null) continue;
    const day = a.scheduledDateISO.slice(0, 10);
    if (day < fromMondayKey || trainedDays.has(day)) continue;
    moves.push({ id: a.id, from: day, to: shiftDayKey(new Date(`${day}T00:00:00Z`), 7) });
  }
  // LATEST FIRST — the order the unique index needs (see the header).
  return moves.sort((x, y) => (x.from === y.from ? x.id.localeCompare(y.id) : x.from < y.from ? 1 : -1));
}

/** The confirm sentence: the count of DAYS, the two exceptions said. */
export function shiftConfirm(moves: readonly ShiftMove[]): string {
  const days = new Set(moves.map((m) => m.from)).size;
  return `Move ${days} assigned ${days === 1 ? "day" : "days"} a week later? Days already trained, and tasks, stay where they are.`;
}
